import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';

// Lazy load ALL pages
const HomePage = lazy(() => import('../pages/HomePage'));
const CastingPage = lazy(() => import('../pages/CastingPage.jsx'));
const EDigestPage = lazy(() => import('../pages/eDigestPage.js'));
const InsideTheCreditsIndex = lazy(() => import('../pages/InsideTheCreditIndexPage.jsx'));
const InsideTheCredits = lazy(() => import('../pages/InsideTheCreditPage.jsx'));
const PollPage = lazy(() => import('../components/Tribe/Poll.jsx'));
const CrewChronicles = lazy(() => import('../components/Tribe/CrewChronicles.jsx'));
const PartnershipPage = lazy(() => import('../pages/PartnershipPage.js'));
const FilmSchoolsPage = lazy(() => import('../pages/FilmSchoolsPage.jsx'));
const FilmSchoolsAdmin = lazy(() => import('../pages/FilmSchoolsAdmin.jsx'));
const HelpPage = lazy(() => import('../pages/HelpPage.js'));
const SearchResults = lazy(() => import('../components/SearchResults.js'));
const RegisterPage = lazy(() => import('../pages/RegisterPage.js'));
const SignInPage = lazy(() => import('../components/SignInPage.js'));
const SubscriptionSuccess = lazy(() => import('../components/SubscriptionSuccess.js'));
const SubscriptionPlans = lazy(() => import('../components/SubscriptionPlans.jsx'));
const PaymentStatus = lazy(() => import('../components/PaymentStatus.js'));
const Profile = lazy(() => import('../components/Profile.js'));
const SpotlightDisplay = lazy(() => import('../components/edigest/Spotlight.jsx'));
const SpotlightSubmit = lazy(() => import('../pages/SpotlightPage.js'));
const MasterclassReservePage = lazy(() => import('../pages/MasterclassReservePage.jsx'));
const LegendsLegacy = lazy(() => import('../components/edigest/LegendsLegacy.jsx'));
const Masterclass = lazy(() => import('../components/edigest/Masterclass.jsx'));
const CommunityLanding = lazy(() => import('../components/Community/CommunityLanding.jsx'));
const CommunityHub = lazy(() => import('../components/CommunityHub.jsx'));
const MessagePage = lazy(() => import('../components/DM/MessagePage.jsx'));
const ProtectedAdminRoute = lazy(() => import('../components/ProtectedAdminRoute.js'));
const AdminDashboard = lazy(() => import('../pages/AdminDashboard.js'));
const PartnerPage = lazy(() => import('../pages/PartnerPage.jsx'));

// Already lazy
const HubPage = lazy(() => import('../pages/HubPage'));
const AboutPage = lazy(() => import('../pages/AboutPage'));
const Connect = lazy(() => import('../components/Connect'));

const MemberPortfolioRedirect = () => {
  const { userId } = useParams();
  return <Navigate to={`/Profile/${encodeURIComponent(userId || '')}`} replace />;
};


function AppRouter({ isAuthenticated }: { isAuthenticated: boolean }) {
return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/hub" element={<HubPage />} />
            <Route path="/hub/:chatRoomId" element={<HubPage />} />
            <Route path="/forum/space/:spaceId" element={<HubPage />} />

                          <Route path="/new-hub" element={<HubPage />} />
                  <Route path="/connect" element={<Connect />} />
                  <Route path="/casting" element={<CastingPage />} />
                  <Route path="/edigest" element={<EDigestPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/poll/:pollId" element={<PollPage />} />
                  <Route path="/crew-chronicles/:crewId" element={<CrewChronicles />} />
                  <Route path="/crew-chronicles" element={<CrewChronicles />} />
        
                            <Route path="/inside-the-credits" element={<InsideTheCreditsIndex />} />
                            <Route path="/inside-the-credit/:eventId" element={<InsideTheCredits />} />
        
        
                  <Route path="/partnership" element={<PartnershipPage />} />
                  <Route path="/film-schools" element={<FilmSchoolsPage />} />
                  <Route path="/admin/film-schools" element={<ProtectedAdminRoute><FilmSchoolsAdmin /></ProtectedAdminRoute>} />
<Route path="/partners/:slug" element={<PartnerPage />} />
                  <Route path="/help" element={<HelpPage />} />
                  <Route path="/search" element={<SearchResults />} />
                  <Route path="/register" element={!isAuthenticated ? <RegisterPage /> : <Connect />} />
                  <Route path="/registration" element={!isAuthenticated ? <RegisterPage /> : <Connect />} />
                  <Route path="/signin" element={<SignInPage onLoginSuccess={undefined} />} />
                  <Route path="/subscription-success" element={<SubscriptionSuccess />} />
                  <Route path="/subscription-plans" element={<SubscriptionPlans />} />
                  <Route path="/payment-status" element={<PaymentStatus />} />
                  <Route path="/Profile/:userId" element={<Profile />} />
                  <Route path="/spotlight/:spotlightId" element={<SpotlightDisplay />} />
                  <Route path="/spotlight/submit" element={<SpotlightSubmit handleClose={undefined} />} />
                  <Route path="/landl/:itemId" element={<LegendsLegacy />} />
                  <Route path="/masterclass/:itemId" element={<Masterclass />} />
                            <Route path="/masterclass-reserve/:masterclassId" element={<MasterclassReservePage />} />
                  
                  <Route path="/communities" element={<CommunityHub fullListing />} />
                  <Route path="/community/:id" element={<CommunityLanding />} />
        
                  <Route path="/Profile/:userId/:profileType" element={<Profile />} />
                  <Route path="/portfolio/:userId" element={<MemberPortfolioRedirect />} />
                  <Route path="/chat" element={<Navigate to="/hub" replace />} />
                  <Route path="/dm" element={<MessagePage />} />
                      <Route path="/dm/:userId" element={<MessagePage />} />
        
                  <Route path="/admin" element={
                    <ProtectedAdminRoute>
                      <AdminDashboard />
                    </ProtectedAdminRoute>
                  } />
                </Routes>
    </Suspense>
  );
}

export default AppRouter;
